import { Form, Select } from "antd";

import { useVendors } from "../../data/use-vendors";
import { filterOption } from "./filter-option";
import { pickFormItemProps, pickSelectProps } from "./pick-props";
import { getSelectOptions } from "../../utils/get-select-options";

export const VendorSelect = (props) => {
  const vendors = useVendors();

  const form = Form.useFormInstance();
  const initialValue = form.getFieldValue(props.name);

  return (
    <Form.Item {...pickFormItemProps(props)}>
      <Select
        showSearch
        optionFilterProp="children"
        filterOption={filterOption}
        options={getSelectOptions({
          store: vendors,
          initialIds: initialValue,
          filter: props.filter,
        })}
        {...pickSelectProps(props)}
      />
    </Form.Item>
  );
};
